<template>
   <div class="container">
        <div class="header">
            <img src="@/assets/img/payslip-header.png"

 alt="Header Background">
            <div class="header-content">
                <div>
                    <img src="@/assets/img/eazi-text-logo.png"
                        alt="eazipay-logo" style="width: 76px;">
                    <h3 style="margin: 5px 0 0; font-weight: 500; font-size: 14px; color: #A0b5B1">Wallet Report</h3>
                </div>
                <div class="report-date">
                    <div>GENERATED ON: {{getDateString(currentDate)}}</div>
                </div>
            </div>
        </div>

        <!-- <div class="report-period">
            <span style="color: #515251">Your wallet report from</span> <span style="font-weight: bold; color: #292A29;">{{getDateString(args.startDate)}} - {{getDateString(args.endDate)}}</span>
        </div> -->

        <div class="details-container">
            <table class="details-table">
                <tbody>
                <tr>
                    <td class="details-column">
                        <table style="width: 100%;">
                            <tbody>
                            <tr class="detail-row">
                                <td class="detail-label">Bank name:</td>
                                <td class="detail-value">{{companyAccount?.bankName||'N/A'}}</td>
                            </tr>
                            <tr class="detail-row">
                                <td class="detail-label">Account Number:</td>
                                <td class="detail-value">{{companyAccount?.accountNumber||'N/A'}}</td>
                            </tr>
                            <tr class="detail-row">
                                <td class="detail-label">Name of Account:</td>
                                <td class="detail-value">{{companyAccount?.accountName||'N/A'}}</td>
                            </tr>
                            <tr class="detail-row">
                                <td class="detail-label">Registered address:</td>
                                <td class="detail-value">{{companyData?.company?.address||'N/A'}}</td>
                            </tr>
                        </tbody>
                        </table>
                    </td>
                    <td class="details-column">
                        <table style="width: 100%;">
                            <tbody>
                            <tr class="detail-row">
                                <td class="detail-label">Currency:</td>
                                <td class="detail-value">NGN</td>
                            </tr>
                            <tr class="detail-row">
                                <td class="detail-label">Opening balance:</td>
                                <td class="detail-value">{{formatAmount(walletReportData?.openningBalance)}}</td>
                            </tr>
                            <tr class="detail-row">
                                <td class="detail-label">Total Debit:</td>
                                <td class="detail-value">{{formatAmount(walletReportData?.totalOutflow)}}</td>
                            </tr>
                            <tr class="detail-row">
                                <td class="detail-label">Total Credit:</td>
                                <td class="detail-value">{{formatAmount(walletReportData?.totalInflow)}}</td>
                            </tr>
                            <tr class="detail-row">
                                <td class="detail-label">Closing balance:</td>
                                <td class="detail-value">{{formatAmount(walletReportData?.closingBalance)}}</td>
                            </tr>
                            <tr class="detail-row">
                                <td class="detail-label">Period:</td>
                                <td class="detail-value">{{getDateString(args.startDate)}} - {{getDateString(args.endDate)}}</td>
                            </tr>
                        </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
            </table>
        </div>

        <table class="transactions-table">
            <thead>
                <tr>
                    <th>DATE</th>
                    <th>DESCRIPTION</th>
                    <th>CREDIT</th>
                    <th>DEBIT</th>
                    <th>BALANCE</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(trx, i) in visibleData" :key="i">
                    <td>{{formatDate(trx.transactionDate)}}</td>
                    <td>{{trx.description}}</td>
                    <td class="amount-column">{{trx.transactionType?.toLowerCase()==='credit'?formatAmount(trx.amount):''}}</td>
                    <td class="amount-column">{{trx.transactionType?.toLowerCase()==='debit'?formatAmount(trx.amount):''}}</td>
                    <td class="amount-column">{{ formatAmount(trx.walletBalance) }}</td>
                </tr>
             
            </tbody>
        </table>

    
        <div  v-if="visibleData.length" class="w-11/12 my-4 mx-auto flex flex-col-reverse md:flex-row justify-between items-center gap-3">
            <p class="text-[10px] text-[#515251] w-full md:mr-36">This statement has been provided by myeazipay.com - a company owned by Myeazipay Technologies Ltd. Our banking services is provided by Ure Microfinance Bank, Nigeria, and customer accounts are also provided by Providus Bank and Wema Bank Plc.  For any clarification, kindly send enquiries to hi@myeazipay.com</p>

            <NewPagination />
        <!-- <easiPagin
  
      :data="visibleData"
      @page:update="updatePage"
      :currentPage="currentPage"
      :pageSize="pageSize"
      class="my-4 w-1/2"
    /> -->
</div>
    </div>
</template>

<script setup>
import NewPagination from '../global/NewPagination.vue';
import { computed, ref, watch } from 'vue';
const visibleData = ref([]);
const currentPage = ref(0);
const pageSize = ref(15);
const props = defineProps({
   

    walletReportData: {
        type: Object,
        required: true
    },
    companyData: {
        type: Object,
        required: true
    },
    companyAccount: {
        type: Object,
        required: true
    },
    fullCompanyData: {
        type: Object,
        required: true
    },
    args: {
        type: Object,
        required: true
    },
    currentDate: {
        type: String,
        required: true
    },
    getDateString: {
        type: Function,
        required: true
    },
    formatAmount: {
        type: Function,
        required: true
    },
    formatDateString: {
        type: Function,
        required: true
    },
    formatDate: {
        type: Function,
        required: true
    },
    getAvatar: {
        type: Function,
        required: true
    }

})
const propD = computed(() => props.walletReportData);


const updatePage = (pageNumber) => {
  currentPage.value = pageNumber;
  updateVisibleData();
};
const updateVisibleData = () => {
  let datas = propD.value?.transactions;
  visibleData.value = datas.slice(
    currentPage.value * pageSize.value,
    currentPage.value * pageSize.value + pageSize.value
  );
  console.log(visibleData.value, 'datas');

  // if we have 0 visible todos, go back a page
  if (visibleData.value.length == 0 && currentPage.value > 0) {
    updatePage(currentPage.value - 1);
  }
};

watch(propD, (val, newVal) => {
  updateVisibleData();
});
</script>

<style scoped>
   

        .container {
            max-width: 100%;
            /* margin: 0 auto; */
            background: #fff;
        }

        .header {
            padding: 0;
            position: relative;
            overflow: hidden;
        }

        .header img {
            width: 100%;
            display: block;
        }

        .header-content {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            padding: 20px 30px;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            color: white;
        }

        .report-date {
            background: rgba(17, 69, 59, 0.4);
            color: white;
            padding: 5px 10px;
            border-radius: 5px;
            align-self: flex-end;
            font-size: 12px;
        }

        .report-period {
            padding: 20px 30px 5px 30px;
            color: #515251;
            font-size: 12px;
        }

        .details-container {
            margin: 25px;
            background: #fff;
            border: 1px solid #E9E9E9;
            border-radius: 8px;
            padding: 12px;
            font-size: 12px;
            width: calc(100% - 50px);
        }

        .details-table {
            width: 100%;
            border-collapse: separate;
            border-spacing: 0;
        }

        .details-table td {
            padding-bottom: 10px;
            vertical-align: top;
        }

        .details-column {
            width: 50%;
        }

        .details-column:first-child {
            border-right: 1px solid #E9E9E9;
            padding-right: 12px;
        }

        .details-column:last-child {
            padding-left: 12px;
        }

        .detail-row {
            width: 100%;
        }

        .detail-label {
            color: #515251;
            font-size: 12px;
        }

        .detail-value {
            font-weight: 700;
            color: #292A29;
            font-size: 12px;
            text-align: right;
        }

        .transactions-table {
            width: calc(100% - 50px);
            margin: 25px;
            border-collapse: separate;
            border-spacing: 0;
        }

        .transactions-table th {
            background: #F3F3F3;
            color: #191919;
            padding: 8px 16px;
            text-align: left;
            font-size: 12px;
            font-weight: 600;
        }

        .transactions-table td {
            padding: 12px 16px;
            border-bottom: 1px solid #eee;
            color: #474747;
            font-size: 12px;
            min-width: 140px;
        }

        .transactions-table tr:last-child td {
            border-bottom: none;
        }

        .transactions-table tr:nth-child(even) {
            background-color: #f8f8f8;
        }

        .amount-column {
            text-align: left;
            font-weight: 500;
        }

        .footer {
            margin-top: 20px;
            padding: 0;
        }

        .footer img {
            width: 100%;
            height: 100%;
            display: block;
        }

        .footer-text {
            color: #fff;
            font-size: 10px;
            line-height: 1.6;
        }

        .page-number {
            text-align: right;
            padding: 10px 25px;
            color: #fff;
            font-size: 12px;
        }

        @media screen and (max-width: 600px) {
            .details-container {
                margin: 15px;
                width: calc(100% - 30px);
            }

            .details-column {
                display: block;
                width: 100%;
                border-right: none;
                border-bottom: 1px solid #E7E8E7;
                padding: 0 0 10px 0;
            }

            .details-column:last-child {
                border-bottom: none;
                padding-top: 10px;
            }

            .transactions-table {
                width: calc(100% - 30px);
                overflow: auto;
                margin: 15px;
            }
        }
    </style>